import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const ICONS = {
  dashboard: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <rect x="3" y="3" width="7" height="9" />
      <rect x="14" y="3" width="7" height="5" />
      <rect x="14" y="12" width="7" height="9" />
      <rect x="3" y="16" width="7" height="5" />
    </svg>
  ),
  ingresos: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <path d="M7 17l5-5 5 5" />
      <path d="M12 12V3" />
      <path d="M3 21h18" />
    </svg>
  ),
  gastos: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <path d="M17 7l-5 5-5-5" />
      <path d="M12 12v9" />
      <path d="M3 3h18" />
    </svg>
  ),
  users: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  logout: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  settings: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  chevron: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-group__chevron"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  facturas: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="16" y2="17" />
      <line x1="9" y1="9" x2="10" y2="9" />
    </svg>
  ),
  tag: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  comisiones: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="nav-link__icon"
    >
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
};

export function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = user?.role === "admin";
  // El comercial sólo ve la sección de Comisiones.
  const isComercial = user?.role === "comercial";
  const configOpenInitial = location.pathname.startsWith("/configuracion");
  const [configOpen, setConfigOpen] = useState(configOpenInitial);

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <span className="sidebar__brand-mark">Paunero &amp; Jerónimo</span>
        <span className="sidebar__brand-sub">Contabilidad</span>
      </div>

      <nav className="sidebar__nav">
        {!isComercial && (
          <>
            <NavLink to="/" end className={navClass}>
              {ICONS.dashboard}
              Dashboard
            </NavLink>
            <NavLink to="/ingresos" className={navClass}>
              {ICONS.ingresos}
              Ingresos
            </NavLink>
            <NavLink to="/gastos" className={navClass}>
              {ICONS.gastos}
              Gastos
            </NavLink>
            <NavLink to="/facturas" className={navClass}>
              {ICONS.facturas}
              Facturas
            </NavLink>
          </>
        )}
        <NavLink to="/comisiones" className={navClass}>
          {ICONS.comisiones}
          Comisiones comercial
        </NavLink>
        {isAdmin && (
          <NavLink to="/usuarios" className={navClass}>
            {ICONS.users}
            Usuarios
          </NavLink>
        )}

        {isAdmin && (
          <div className={`nav-group ${configOpen ? "nav-group--open" : ""}`}>
            <button
              type="button"
              className="nav-group__toggle"
              aria-expanded={configOpen}
              onClick={() => setConfigOpen((v) => !v)}
            >
              {ICONS.settings}
              <span className="nav-group__label">Configuración</span>
              {ICONS.chevron}
            </button>
            {configOpen && (
              <div className="nav-group__items">
                <NavLink to="/configuracion/categorias" className={subNavClass}>
                  {ICONS.tag}
                  Categorías
                </NavLink>
              </div>
            )}
          </div>
        )}
      </nav>

      <div className="sidebar__user">
        {user && (
          <div className="sidebar__user-info" title={user.email}>
            <div className="sidebar__user-email">{user.email}</div>
            <div className="sidebar__user-role">{user.role}</div>
          </div>
        )}
        <button type="button" className="sidebar__logout" onClick={handleLogout}>
          {ICONS.logout}
          Cerrar sesión
        </button>
      </div>

      <div className="sidebar__footer">v0.3 · auth + D1</div>
    </aside>
  );
}

function navClass({ isActive }: { isActive: boolean }): string {
  return isActive ? "nav-link nav-link--active" : "nav-link";
}

function subNavClass({ isActive }: { isActive: boolean }): string {
  return isActive ? "nav-link nav-link--sub nav-link--active" : "nav-link nav-link--sub";
}
